module.exports = __webpack_public_path__ + "static/media/opstart.32b82ca1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/opstart.svg
// module id = 619
// module chunks = 0